var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header__wrapper",class:_vm.wrapperDynamicClass},[_c('div',{staticClass:"header__container"},[_c('a-header-logo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }